import React from 'react';
import { Maximize, Minimize } from 'lucide-react';

interface FullscreenControlsProps {
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
}

const FullscreenControls: React.FC<FullscreenControlsProps> = ({
  isFullscreen,
  onToggleFullscreen
}) => {
  return (
    <div className="fullscreen-controls">
      <button 
        className="fullscreen-btn tooltip-container"
        onClick={onToggleFullscreen}
        aria-label={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
        title={isFullscreen ? "Click to exit fullscreen" : "Click to make the browser fullscreen"}
      >
        {isFullscreen ? (
          <>
            <Minimize size={16} />
            <span>Exit Fullscreen</span>
          </>
        ) : (
          <>
            <Maximize size={16} />
            <span>Go Fullscreen</span>
          </>
        )}
        <div className="tooltip">Click to make the browser fullscreen</div>
      </button>
    </div>
  );
};

export default FullscreenControls;
